import { render } from "./SpineNav.vue?vue&type=template&id=05527cb9&scoped=true"
import script from "./SpineNav.vue?vue&type=script&lang=js"
export * from "./SpineNav.vue?vue&type=script&lang=js"

import "./SpineNav.vue?vue&type=style&index=0&id=05527cb9&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05527cb9"]])

export default __exports__